import '@firebase/firestore-compat';
//# sourceMappingURL=index.esm.js.map



//////////////////
// WEBPACK FOOTER
// ./~/firebase/compat/firestore/dist/index.esm.js
// module id = 5
// module chunks = 14